import { render, staticRenderFns } from "./V2Layout.vue?vue&type=template&id=945b4e1a&scoped=true"
import script from "./V2Layout.vue?vue&type=script&lang=js"
export * from "./V2Layout.vue?vue&type=script&lang=js"
import style0 from "./V2Layout.vue?vue&type=style&index=0&id=945b4e1a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945b4e1a",
  null
  
)

export default component.exports